import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles({
  tooltip: {
    maxWidth: "260px",
    // maxHeight: "96px",
    background: "#FFFFFF 0% 0% no-repeat padding-box",
    color: "black",
    border: "#70707075 1px solid",
    boxShadow: "0px 3px 6px #00000029",
    opacity: 1,
    fontSize: 12
    // marginTop: "0px",
  },
  arrow: {
    "&:before": {
      border: "1px solid #70707075"
    },
    color: "white",
    fontSize: 15
  },
  formContainer: {
    display: "flex !important",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    gap: "16px",
    padding: "8px 16px",
    width: "100%"
  },

  tooltipIcon: {
    marginLeft: "8px",
  },

  header: { alignSelf: "start" },

  heading: {
    fontSize: "14px",
    fontWeight: "400",
    margin: "0 !important"
  },

  form: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    width: "100%",
    height: "100%"
  },

  formGroup: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    marginBottom: "0 !important"
  },
  labelContainer: { display: "flex", justifyContent: "space-between" },
  nameEditIcon: { width: "14px", height: "14px", cursor: "pointer" },
  toggleGroup: {
    justifyContent: "space-between",
    flexDirection: "row"
  },

  checkboxStyle3Container: {
    display: "flex",
    gap: "16px"
  },

  checkboxStyle3Div: {
    display: "inline-flex",
    height: "28px",
    padding: "3px 12px",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "64px",
    border: "1px solid #C4C4C4",
    background: "#FFF",
    cursor: "pointer",

    "&:hover":{
    backgroundColor: "#F8F8F8"
    }
  },

  checkboxStyle3DivSelected: {
    border: "1px solid #0072C6",
    background: "#F0F8FF",

    "&:hover":{
    background: "#F0F8FF"
    }

  },

  checkboxStyle3DivDisabled: {
    border: "1px solid #C4C4C4",
    background: "#F0F0F0"
  },

  checkboxStyle3DivSelectedDisabled: {
    border: "1px solid #AED3EE",
    background: "#F0F8FF",
    color: "#C4C4C4",

    "&:hover":{
    background: "#F0F8FF"
    }

  },

  footer: {
    flexDirection: "column",
    justifyContent: (style) => (style.marvinRequestSent ? "space-between" : "end"),
    alignItems: "center",
    position: "fixed",
    bottom: "0",
    left: "0",
    width: "100%",
    marginTop: "0",
    backgroundColor: "#f8f8f8",
    borderTop: "1px solid #c4c4c4"
  },

  label: {
    margin: "0 !important",
    fontSize: "12px",
    fontWeight: "600"
  },
  labelOptional: {
    color: "#606060"
  },

  input: {
    width: "100%",
    borderRadius: "5px",

    "&::placeholder": {
      color: "#d7d7d7",
      fontSize: "12px",
      backgroundColor: "transparent !important"
    },

    "&:focus": {
      border: "1px solid #0072c6 !important",
      outline: "none !important",
      // boxShadow: "0 0 5px #0072c6 !important"
    },
    "&:hover": {
      border: "1px solid #0072c6 !important",
      outline: "none !important",
      // boxShadow: "0 0 5px #0072c6 !important"
    }
  },

  textarea: {
    resize: "none !important",
    paddingRight: style =>style.isListening ? "22px !important" : "20px !important"
  },

  mandatoryAstrik: { color: "red", marginLeft: "5px" },

  buttonGroup: {
    display: "flex",
    gap: "12px",
    marginBottom: "0 !important",
    alignItems: "center",
    width:"100%",
    justifyContent:"end"    
  },

  button: {
    fontSize: "12px !important",
    fontWeight: "600 !important",
    border: "1px solid #0072c655 !important",
    borderRadius: "2px !important",
    margin: "0 !important",
    padding: "0px 12px !important",
    height: "auto !important",

    "&:focus": {
      boxShadow: "0 0 15px 0px rgba(255, 0, 0, 0.2)"
    }
  },

  primaryButton: {
    background: "linear-gradient(91.63deg, #51087E -3.09%, #A14653 78.68%, #FB8B23 137.5%) !important",
    // backgroundColor: "#0072c6 !important",
    color: "#fff !important",

    "&:focus": {
      backgroundColor: "#0072c6 !important"
    },

    "&:focus-within": {
      backgroundColor: "#dcdcdc !important"
    }
  },

  secondaryButton: {
    backgroundColor: "#fff !important",
    color: "#606060 !important",
    border: "1px solid #C4C4C4 !important"
  },
  speechToText: {
    position: "absolute",
    right: "0%",
    bottom: "19%",
    marginBottom: "4pt",
    marginRight: "4pt",
    cursor: "pointer",
    
    "&:hover":{
    borderRadius:style=>style.isTablet || style.isMobile ? null : "100%",
    backgroundColor:style=>style.isTablet || style.isMobile ? null : "#F8F8F8"
    }
  },
  speechToTextListening: {
    marginBottom: "4pt",
    marginRight: "4pt",
    borderRadius: "100%",
    animation: "wave-animation 1.5s linear infinite",    
  },
  speechToTextImg: {
    width: "16px",
    height: "16px",
    margin: "4px",

    "& path":{
      stroke: style=>style.isListening ? "#0072c6" : null
    },
    "&:hover":{
      "& path":{
        stroke:style=>style.isTablet || style.isMobile ? null : "#0072c6",        
      }
    }
  },
  textareaPosition: {
    position: "relative"
  },
  clearInput: {
    fontFamily: "Open Sans",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: "400",
    lineHeight: "12px",
    textAlign: "right"
  },
  clearInputDisabled: {
    color: "#C4C4C4"
  },
  clearInputEnabled: {
    color: "#0072C6",
    cursor: "pointer",

    "&:hover": {
      textDecorationLine: "underline"
    }
  },
  button1: {
    display: "inline-block !important",
    border: "none !important",
    outline: "none !important",
    appearance: "none !important",
    position: "relative !important",
    zIndex: "3 !important",
    borderRadius: "5px !important",
    fontSize: "12px !important",
    fontWeight: "700 !important",
    margin: "0 !important",
    padding: "1px 12px !important",
    height: "auto !important",

    "&:before": {
      content: '"Re-generate"',
      zIndex: "-1 !important",
      borderRadius: "3px !important"
    },

    "&:after": {
      content: '""',
      position: "absolute !important",
      left: "2px !important",
      right: "2px !important",
      top: "2px !important",
      bottom: "2px !important",
      zIndex: "-2 !important",
      borderRadius: "3px !important",
      background: "white !important"
    }
  },

  regenerateButton: {
    background: "linear-gradient(91.63deg, #51087E -3.09%, #A14653 78.68%, #FB8B23 137.5%) !important",

    "&:before": {
      background: "linear-gradient(91.63deg, #51087E -3.09%, #A14653 78.68%, #FB8B23 137.5%) !important",
      "-webkit-background-clip": "text !important",
      "-webkit-text-fill-color": "transparent !important"
    }
  },
  footerText:{
    fontFamily: "Open Sans",
    fontSize: "10px",
    fontWeight: "400",
    lineHeight: "12px",
    borderTop: "1px solid #F0F0F0",
    width:"100%",
    display:"flex",
    alignItems: "center",
    justifyContent: "center",
    paddingTop: "4px",
    paddingBottom: "4px",
    color: "#606060"
  },
});
